import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const StandardFilterField = iotsUtils.fromList(
	constants.principal.search.standardFilterFields
);

export const FilterField = iotsUtils.fromList(constants.principal.search.filterFields);
